import { Api } from '../../../utils/config';
import { Http } from '../../../utils/http';
import { GetClientType } from '../../../utils/env'

const optionURL = (voteid: string, optionid: string, token: string, unionId: string): string => Api().host + `/votecenter/activity/${voteid}/options/${optionid}/vote_info?user_token=${token}&union_id=${unionId}`

const getOptionInfo = async (voteid: string, optionid: string, token: string, unionId: string) => {
    const data = await Http.get(optionURL(voteid, optionid, token, unionId))
    return data.data;
}

// voting
const votingURL = (voteid: string, optionid: string, token: string, unionId: string, validate: string): string =>
    Api().host + `/votecenter/activity/${voteid}/options/${optionid}/vote?user_token=${token}&validate=${validate}&union_id=${unionId}+&client_type=${GetClientType()}`
const goVoting = async (voteid: string, optionid: string, token: string, unionId: string, validate: string) => {
    return await Http.get(votingURL(voteid, optionid, token, unionId, validate));
}
const goVotingALL = async (voteid: string, optionid: string, token: string, unionId: string, validate: string) => {
    return await Http.get(votingURL(voteid, optionid, token, unionId, validate) + '&is_all=1');
}
export {
    getOptionInfo,
    goVoting,
    goVotingALL
}


// WEBPACK FOOTER //
// ./src/components/common/voting/api.ts